<template>
  <div class="container page" style="background: #f4f4f4;">
    <div class="header">
      <van-nav-bar title="账变记录" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#333" @click="back()" />
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
          <div v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div class="topInfo">
              <span>{{typeObj[v.type]}}</span>
              <span>金额：{{v.change_amount}}</span>
            </div>
            <div class="time">
              <span>{{$t("withdraw.desc")}}：{{v.remark}}</span>
            </div>
            <div class="time">
              <span>变动前金额：{{v.balance_before}}</span>
            </div>
            <div class="time">
              <span>变动后金额：{{v.balance_after}}</span>
            </div>
            <div class="time">
              <span>操作时间：{{v.create_time}}</span>
            </div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[],
      typeObj:{
        recharge:'充值',
        withdraw:'提现',
        withdraw_refund:'提现返回',
        bet:'认证',
        bet_result:'认证返回',
      }
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getUserWithdrawList()
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'getMoneyLog'
      }).then(res=>{
        this.isLoading=false
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 15px 15px;
  margin: 20px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
  color: #333;
}

.item_list .topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.item_list .topInfo span{
  font-size: 32px;
  font-weight: 700;
}

.item_list .time span{
  font-size: 25px;
  font-weight: 500;
  color: #333;
  line-height: 40px;
}

</style>
